import React from "react";
import { Link, NavLink, Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LogOut, Home, Building2, Map, Newspaper, MessageSquareQuote, HelpCircle, Inbox, Mail, Settings as SettingsIcon } from "lucide-react";

const items = [
  { to: "/admin", label: "Painel", icon: Home, end: true },
  { to: "/admin/imoveis", label: "Imóveis", icon: Building2 },
  { to: "/admin/zonas", label: "Zonas", icon: Map },
  { to: "/admin/blog", label: "Blog", icon: Newspaper },
  { to: "/admin/testemunhos", label: "Testemunhos", icon: MessageSquareQuote },
  { to: "/admin/faqs", label: "FAQs", icon: HelpCircle },
  { to: "/admin/leads", label: "Contactos", icon: Inbox },
  { to: "/admin/newsletter", label: "Newsletter", icon: Mail },
  { to: "/admin/definicoes", label: "Definições", icon: SettingsIcon },
];

export default function AdminLayout({ children }) {
  const { user, checked, logout } = useAuth();
  const navigate = useNavigate();

  if (checked && !user) return <Navigate to="/login" replace />;
  if (!checked) return <div className="p-10">A carregar...</div>;

  return (
    <div className="min-h-screen bg-stone-50 flex">
      <aside data-testid="admin-sidebar" className="w-64 shrink-0 border-r border-stone-200 bg-white min-h-screen sticky top-0 self-start">
        <div className="p-6 border-b border-stone-200">
          <Link to="/" className="flex items-center">
            <img src="/logo.png" alt="casa no porto" className="h-7 w-auto" />
          </Link>
          <div className="mt-4 text-xs uppercase tracking-widest text-stone-500">CMS</div>
        </div>
        <nav className="p-3">
          {items.map((it) => (
            <NavLink key={it.to} to={it.to} end={it.end} data-testid={`admin-nav-${it.to.split("/").pop()}`}
              className={({ isActive }) => `flex items-center gap-3 rounded-lg px-3 py-2 my-0.5 text-sm ${isActive ? "bg-[#103C4A] text-white" : "text-stone-700 hover:bg-stone-100"}`}>
              <it.icon className="h-4 w-4" /> {it.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 mt-6 border-t border-stone-200">
          <button onClick={() => { logout(); navigate("/login"); }} data-testid="admin-logout" className="flex items-center gap-2 w-full rounded-lg px-3 py-2 text-sm text-stone-700 hover:bg-stone-100">
            <LogOut className="h-4 w-4" /> Sair
          </button>
        </div>
      </aside>
      <main className="flex-1 p-8 max-w-full overflow-x-hidden">
        <div className="max-w-6xl mx-auto">{children}</div>
      </main>
    </div>
  );
}
